import React, { Component } from "react";
import ApiProductList from "../apiProductList/apiProductList";
import { Link } from "react-router-dom";
import { getRouteUrl } from "../../routers";
import { ROUTE_PRODUCT_DOCUMENTATION } from "../../routers/content/product";

class ApiProductTableRow extends Component {
  state = {
    open: false,
  };

  toggleOpen = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  //unused props uuid // state:  open
  render() {
    const { title, productId, productAlias, alias } = this.props;
    const productRouteIdentifier = productAlias || productId;

    console.log("apiProductTableRow - API data:", {
      title,
      productId,
      productAlias,
      alias,
      allProps: this.props,
    });

    // Use alias which already contains the full path like "/documentation/Account-Information-Berlin-Group-v1"
    const docsUrl = alias || `/documentation/${title || ""}`;

    console.log("apiProductTableRow - Generated docsUrl:", docsUrl);
    return (
      <div>
        <ApiProductList liclassName="row accord_title">
          <div className="cell" data-title="PLAN NAME">
            <div className="arr_line_1">
              {title}
              {productId && title ? (
                <div style={{ marginTop: 6, display: "flex", gap: 12 }}>
                  <Link
                    to={docsUrl}
                    className="api-docs-link"
                    title={`View technical documentation for ${title}`}
                  >
                    Technical Documentation
                  </Link>
                </div>
              ) : null}
            </div>
          </div>
          <div className="cell accordion_column">
            {/*    <button className="tbl_arrow_efect"*/}
            {/*            onClick={this.toggleOpen}>*/}
            {/*        <span className="icon-arrow_classic_down"/>*/}
            {/*    </button>*/}
          </div>
          <div className="cell" data-title="DEFAULT PLAN">
            <div className="arr_line_1">100 per hour</div>
          </div>
        </ApiProductList>
      </div>
    );
  }
}

export default ApiProductTableRow;
